var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrawn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 191.65 189.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{mask:url(#mask);filter:url(#luminosity-noclip-2);}.cls-12,.cls-16,.cls-2,.cls-20,.cls-24,.cls-28,.cls-32,.cls-36,.cls-40,.cls-44,.cls-48,.cls-52,.cls-57,.cls-6,.cls-8{mix-blend-mode:multiply;}.cls-2{fill:url(#linear-gradient);}.cls-3{mask:url(#mask-2);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{mask:url(#mask-3);filter:url(#luminosity-noclip-32);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{mask:url(#mask-4);filter:url(#luminosity-noclip-5);}.cls-8{fill:url(#linear-gradient-4);}.cls-9{mask:url(#mask-5);}.cls-10{fill:url(#linear-gradient-5);}.cls-11{mask:url(#mask-6);filter:url(#luminosity-noclip-7);}.cls-12{fill:url(#linear-gradient-6);}.cls-13{mask:url(#mask-7);}.cls-14{fill:url(#linear-gradient-7);}.cls-15{mask:url(#mask-8);filter:url(#luminosity-noclip-9);}.cls-16{fill:url(#linear-gradient-8);}.cls-17{mask:url(#mask-9);}.cls-18{fill:url(#linear-gradient-9);}.cls-19{mask:url(#mask-10);filter:url(#luminosity-noclip-11);}.cls-20{fill:url(#linear-gradient-10);}.cls-21{mask:url(#mask-11);}.cls-22{fill:url(#linear-gradient-11);}.cls-23{mask:url(#mask-12);filter:url(#luminosity-noclip-13);}.cls-24{fill:url(#linear-gradient-12);}.cls-25{mask:url(#mask-13);}.cls-26{fill:url(#linear-gradient-13);}.cls-27{mask:url(#mask-14);filter:url(#luminosity-noclip-15);}.cls-28{fill:url(#linear-gradient-14);}.cls-29{mask:url(#mask-15);}.cls-30{fill:url(#linear-gradient-15);}.cls-31{mask:url(#mask-16);filter:url(#luminosity-noclip-17);}.cls-32{fill:url(#linear-gradient-16);}.cls-33{mask:url(#mask-17);}.cls-34{fill:url(#linear-gradient-17);}.cls-35{mask:url(#mask-18);filter:url(#luminosity-noclip-19);}.cls-36{fill:url(#linear-gradient-18);}.cls-37{mask:url(#mask-19);}.cls-38{fill:url(#linear-gradient-19);}.cls-39{mask:url(#mask-20);filter:url(#luminosity-noclip-21);}.cls-40{fill:url(#linear-gradient-20);}.cls-41{mask:url(#mask-21);}.cls-42{fill:url(#linear-gradient-21);}.cls-43{mask:url(#mask-22);filter:url(#luminosity-noclip-23);}.cls-44{fill:url(#linear-gradient-22);}.cls-45{mask:url(#mask-23);}.cls-46{fill:url(#linear-gradient-23);}.cls-47,.cls-55{mask:url(#mask-24);}.cls-47{filter:url(#luminosity-noclip-25);}.cls-48{fill:url(#linear-gradient-24);}.cls-49{mask:url(#mask-25);}.cls-50{fill:url(#linear-gradient-25);}.cls-51{mask:url(#mask-26);filter:url(#luminosity-noclip-27);}.cls-52{fill:url(#linear-gradient-26);}.cls-53{mask:url(#mask-27);}.cls-54{fill:url(#linear-gradient-27);}.cls-56{mask:url(#mask-30);filter:url(#luminosity-noclip-31);}.cls-57{fill:url(#linear-gradient-30);}.cls-58{mask:url(#mask-31);}.cls-59{fill:url(#linear-gradient-31);}.cls-60{mask:url(#mask-32);}.cls-61{fill:url(#linear-gradient-32);}.cls-62{fill:#ef395f;}.cls-63{mask:url(#mask-33);}.cls-64{fill:#971d39;}.cls-65{mask:url(#mask-34);}.cls-66{mask:url(#mask-35);}.cls-67{mask:url(#mask-36);}.cls-68{mask:url(#mask-37);}.cls-69{mask:url(#mask-38);}.cls-70{mask:url(#mask-39);}.cls-71{fill:#f2617f;}.cls-72{mask:url(#mask-40);}.cls-73{mask:url(#mask-41);}.cls-74{mask:url(#mask-42);}.cls-75{mask:url(#mask-43);}.cls-76{mask:url(#mask-44);}.cls-77{mask:url(#mask-45);}.cls-78{mask:url(#mask-46);}.cls-79{mask:url(#mask-47);}.cls-80{filter:url(#luminosity-noclip-30);}.cls-81{filter:url(#luminosity-noclip-26);}.cls-82{filter:url(#luminosity-noclip-24);}.cls-83{filter:url(#luminosity-noclip-22);}.cls-84{filter:url(#luminosity-noclip-20);}.cls-85{filter:url(#luminosity-noclip-18);}.cls-86{filter:url(#luminosity-noclip-16);}.cls-87{filter:url(#luminosity-noclip-14);}.cls-88{filter:url(#luminosity-noclip-12);}.cls-89{filter:url(#luminosity-noclip-10);}.cls-90{filter:url(#luminosity-noclip-8);}.cls-91{filter:url(#luminosity-noclip-6);}.cls-92{filter:url(#luminosity-noclip-4);}.cls-93{filter:url(#luminosity-noclip-3);}.cls-94{filter:url(#luminosity-noclip);}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 50.99,
    y: -8241.7,
    width: 75.38,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 50.99,
    y: -8241.7,
    width: 75.38,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 27908.48,
    y1: -17713.94,
    x2: 21558.55,
    y2: -14125.67,
    gradientTransform: "matrix(0.03, 0, 0, -0.03, -557.57, -242.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 50.99,
    y: 166.82,
    width: 75.38,
    height: 22.42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 50.99,
    y: 166.82,
    width: 75.38,
    height: 22.42,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 50.99,
    y: 166.82,
    width: 75.38,
    height: 22.42
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 27908.48,
    y1: -17713.94,
    x2: 21558.55,
    y2: -14125.67,
    gradientTransform: "matrix(0.03, 0, 0, -0.03, -557.57, -242.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 30.32,
    y: -8241.7,
    width: 52.52,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 30.32,
    y: -8241.7,
    width: 52.52,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 24414.81,
    y1: -7397.1,
    x2: 21042.65,
    y2: -16414.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 39.95,
    y: -8241.7,
    width: 42.88,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 39.95,
    y: -8241.7,
    width: 42.88,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 20822.72,
    y1: -13306.38,
    x2: 22645.08,
    y2: -15645.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-5",
    x: 39.95,
    y: 155.83,
    width: 42.88,
    height: 33.39,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 39.95,
    y: 155.83,
    width: 42.88,
    height: 33.39,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 39.95,
    y: 155.83,
    width: 42.88,
    height: 33.39
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 20822.72,
    y1: -13306.38,
    x2: 22645.08,
    y2: -15645.37,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-6",
    x: 22.08,
    y: -8241.7,
    width: 19.79,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 22.08,
    y: -8241.7,
    width: 19.79,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 23866.87,
    y1: -1221.95,
    x2: 19959.58,
    y2: -18006.45,
    gradientTransform: "matrix(0.03, 0, 0, -0.03, -557.57, -242.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-7",
    x: 22.08,
    y: 155.83,
    width: 19.79,
    height: 11.11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: 22.08,
    y: 155.83,
    width: 19.79,
    height: 11.11,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 22.08,
    y: 155.83,
    width: 19.79,
    height: 11.11
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 23866.87,
    y1: -1221.95,
    x2: 19959.58,
    y2: -18006.45,
    gradientTransform: "matrix(0.03, 0, 0, -0.03, -557.57, -242.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-8",
    x: 7.11,
    y: -8241.7,
    width: 66.59,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 7.11,
    y: -8241.7,
    width: 66.59,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 16855.27,
    y1: -15199.44,
    x2: 23223.95,
    y2: -8436.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-9",
    x: 7.11,
    y: 38.7,
    width: 66.59,
    height: 41.67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    x: 7.11,
    y: 38.7,
    width: 66.59,
    height: 41.67,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 7.11,
    y: 38.7,
    width: 66.59,
    height: 41.67
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 16855.27,
    y1: -15199.44,
    x2: 23223.95,
    y2: -8436.24,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-10",
    x: 42.96,
    y: -8241.7,
    width: 33.87,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    x: 42.96,
    y: -8241.7,
    width: 33.87,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 23564.09,
    y1: -7078.77,
    x2: 20191.85,
    y2: -16096.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-11",
    x: 42.96,
    y: 75.27,
    width: 33.87,
    height: 30.02,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    x: 42.96,
    y: 75.27,
    width: 33.87,
    height: 30.02,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 42.96,
    y: 75.27,
    width: 33.87,
    height: 30.02
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 23564.09,
    y1: -7078.77,
    x2: 20191.85,
    y2: -16096.46,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-12",
    x: 56.35,
    y: -8241.7,
    width: 27.49,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    x: 56.35,
    y: -8241.7,
    width: 27.49,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 24405.68,
    y1: -1346.19,
    x2: 20498.04,
    y2: -18132.15,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-13",
    x: 56.35,
    y: 38.7,
    width: 27.49,
    height: 55.94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    x: 56.35,
    y: 38.7,
    width: 27.49,
    height: 55.94,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 56.35,
    y: 38.7,
    width: 27.49,
    height: 55.94
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 24405.68,
    y1: -1346.19,
    x2: 20498.04,
    y2: -18132.15,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-14",
    x: -0.28,
    y: -8241.7,
    width: 20.12,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    x: -0.28,
    y: -8241.7,
    width: 20.12,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 17100.18,
    y1: -15429.97,
    x2: 23468.77,
    y2: -8666.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-15",
    x: -0.28,
    y: 79.06,
    width: 20.12,
    height: 53.77,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    x: -0.28,
    y: 79.06,
    width: 20.12,
    height: 53.77,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.28,
    y: 79.06,
    width: 20.12,
    height: 53.77
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 17100.18,
    y1: -15429.97,
    x2: 23468.77,
    y2: -8666.87,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-16",
    x: 23.27,
    y: -8241.7,
    width: 17.25,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    x: 23.27,
    y: -8241.7,
    width: 17.25,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 23270.35,
    y1: -6968.96,
    x2: 19898.13,
    y2: -15986.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-17",
    x: 23.27,
    y: 120.9,
    width: 17.25,
    height: 37.82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-17",
    x: 23.27,
    y: 120.9,
    width: 17.25,
    height: 37.82,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 23.27,
    y: 120.9,
    width: 17.25,
    height: 37.82
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 23270.35,
    y1: -6968.96,
    x2: 19898.13,
    y2: -15986.58,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-18",
    x: 24.35,
    y: -8241.7,
    width: 26.22,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    x: 24.35,
    y: -8241.7,
    width: 26.22,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 23065.85,
    y1: -6892.51,
    x2: 19693.65,
    y2: -15910.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-19",
    x: 24.35,
    y: 91.73,
    width: 26.22,
    height: 31.11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-19",
    x: 24.35,
    y: 91.73,
    width: 26.22,
    height: 31.11,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 24.35,
    y: 91.73,
    width: 26.22,
    height: 31.11
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 23065.85,
    y1: -6892.51,
    x2: 19693.65,
    y2: -15910.12,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-20",
    x: 7.11,
    y: -8241.7,
    width: 43.46,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    x: 7.11,
    y: -8241.7,
    width: 43.46,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 23239.47,
    y1: -1074.79,
    x2: 19331.87,
    y2: -17860.59,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-21",
    x: 7.11,
    y: 79.05,
    width: 43.46,
    height: 30.72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-21",
    x: 7.11,
    y: 79.05,
    width: 43.46,
    height: 30.72,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 7.11,
    y: 79.05,
    width: 43.46,
    height: 30.72
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 23239.47,
    y1: -1074.79,
    x2: 19331.87,
    y2: -17860.59,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-22",
    x: 56.35,
    y: -8241.7,
    width: 125.72,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    x: 56.35,
    y: -8241.7,
    width: 125.72,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 28551.5,
    y1: -9467.67,
    x2: 20830.23,
    y2: -10538.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-23",
    x: 56.35,
    y: 36.09,
    width: 125.72,
    height: 15.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-23",
    x: 56.35,
    y: 36.09,
    width: 125.72,
    height: 15.8,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 56.35,
    y: 36.09,
    width: 125.72,
    height: 15.8
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 28551.5,
    y1: -9467.67,
    x2: 20830.23,
    y2: -10538.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-24",
    x: 70.39,
    y: -8241.7,
    width: 80.78,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    x: 70.39,
    y: -8241.7,
    width: 80.78,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 13875.78,
    y1: -13964.75,
    x2: 25692.51,
    y2: -10451.66,
    gradientTransform: "matrix(0.03, 0, 0, -0.03, -557.57, -242.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-25",
    x: 70.39,
    y: 50.54,
    width: 80.78,
    height: 41.12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-25",
    x: 70.39,
    y: 50.54,
    width: 80.78,
    height: 41.12,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 70.39,
    y: 50.54,
    width: 80.78,
    height: 41.12
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 13875.78,
    y1: -13964.75,
    x2: 25692.51,
    y2: -10451.66,
    gradientTransform: "matrix(0.03, 0, 0, -0.03, -557.57, -242.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-26",
    x: 50.99,
    y: -8241.7,
    width: 31.85,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    x: 50.99,
    y: -8241.7,
    width: 31.85,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 23390.38,
    y1: -16205.07,
    x2: 21417.77,
    y2: -14354.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-27",
    x: 50.99,
    y: 173.41,
    width: 31.85,
    height: 15.81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-27",
    x: 50.99,
    y: 173.41,
    width: 31.85,
    height: 15.81,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 50.99,
    y: 173.41,
    width: 31.85,
    height: 15.81
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 23390.38,
    y1: -16205.07,
    x2: 21417.77,
    y2: -14354.57,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-30",
    x: 2.33,
    y: -8241.7,
    width: 37.82,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-30",
    x: 2.33,
    y: -8241.7,
    width: 37.82,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 23237.84,
    y1: -1074.86,
    x2: 19330.38,
    y2: -17860.07,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-31",
    x: 2.33,
    y: 120.9,
    width: 37.82,
    height: 11.93,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-31",
    x: 2.33,
    y: 120.9,
    width: 37.82,
    height: 11.93,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 2.33,
    y: 120.9,
    width: 37.82,
    height: 11.93
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 23237.84,
    y1: -1074.86,
    x2: 19330.38,
    y2: -17860.07,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-32",
    x: 30.32,
    y: 155.83,
    width: 52.52,
    height: 33.42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-32",
    x: 30.32,
    y: 155.83,
    width: 52.52,
    height: 33.42,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 30.32,
    y: 155.83,
    width: 52.52,
    height: 33.42
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 24414.81,
    y1: -7397.1,
    x2: 21042.65,
    y2: -16414.58,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-33",
    x: 50.99,
    y: 166.82,
    width: 75.38,
    height: 22.42,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 50.99,
    y: 166.82,
    width: 75.38,
    height: 22.42
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-34",
    x: 23.27,
    y: 120.9,
    width: 17.25,
    height: 37.82,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 23.27,
    y: 120.9,
    width: 17.25,
    height: 37.82
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-35",
    x: 2.33,
    y: 120.9,
    width: 37.82,
    height: 11.93,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 2.33,
    y: 120.9,
    width: 37.82,
    height: 11.93
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-36",
    x: 30.32,
    y: 155.83,
    width: 52.52,
    height: 33.42,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 30.32,
    y: 155.83,
    width: 52.52,
    height: 33.42
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-37",
    x: 39.95,
    y: 155.83,
    width: 42.88,
    height: 33.39,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 39.95,
    y: 155.83,
    width: 42.88,
    height: 33.39
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-38",
    x: 22.08,
    y: 155.83,
    width: 19.79,
    height: 11.11,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 22.08,
    y: 155.83,
    width: 19.79,
    height: 11.11
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-39",
    x: 7.11,
    y: 38.7,
    width: 66.59,
    height: 41.67,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 7.11,
    y: 38.7,
    width: 66.59,
    height: 41.67
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-40",
    x: 42.96,
    y: 75.27,
    width: 33.87,
    height: 30.02,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 42.96,
    y: 75.27,
    width: 33.87,
    height: 30.02
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-41",
    x: 56.35,
    y: 38.7,
    width: 27.49,
    height: 55.94,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 56.35,
    y: 38.7,
    width: 27.49,
    height: 55.94
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-42",
    x: -0.28,
    y: 79.06,
    width: 20.12,
    height: 53.77,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: -0.28,
    y: 79.06,
    width: 20.12,
    height: 53.77
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-43",
    x: 24.35,
    y: 91.73,
    width: 26.22,
    height: 31.11,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id20"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 24.35,
    y: 91.73,
    width: 26.22,
    height: 31.11
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-44",
    x: 7.11,
    y: 79.05,
    width: 43.46,
    height: 30.72,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 7.11,
    y: 79.05,
    width: 43.46,
    height: 30.72
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-45",
    x: 56.35,
    y: 36.09,
    width: 125.72,
    height: 15.8,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 56.35,
    y: 36.09,
    width: 125.72,
    height: 15.8
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-46",
    x: 70.39,
    y: 50.54,
    width: 80.78,
    height: 41.12,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id26"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 70.39,
    y: 50.54,
    width: 80.78,
    height: 41.12
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-47",
    x: 50.99,
    y: 173.41,
    width: 31.85,
    height: 15.81,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id28"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 50.99,
    y: 173.41,
    width: 31.85,
    height: 15.81
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M75.28,156.9a28.62,28.62,0,0,0-2.87.15h0s-1.92,19.29-21.14,16.64c3.79,11.7,17,15.63,31.28,15.24h0a76,76,0,0,0,43.53-18.11h0s-11.91-10.64-32.57-4.39h0a21.16,21.16,0,0,0-18.23-9.53Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M82.55,188.93c-14.3.39-27.49-3.54-31.28-15.24,9.08,1.25,14.29-2.39,17.27-6.58,20.2,16.46,57.54,3.71,57.54,3.71a76,76,0,0,1-43.53,18.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M76.32,189.18h.08c2.07,0,4.12-.09,6.15-.25h0a50.33,50.33,0,0,1-31.28-15.24h0a50.64,50.64,0,0,1-5.83-7.29h0a49.94,49.94,0,0,1-5.2-10.29h0a22.13,22.13,0,0,0-7.3-1.44h0c-9.64,0-11.47,9.35-10.56,12h0a77.1,77.1,0,0,0,15.86,12.24h0a75.68,75.68,0,0,0,37.29,10.28h.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M26.19,119.39c-8.36,0-16.42,3.91-23.58,13.16h0a76.54,76.54,0,0,0,19.76,34.1c0-.06,4.08-10,17.87-10.54h0a49.89,49.89,0,0,1-3.08-17.29h0a49.84,49.84,0,0,1,2.71-16.26h0a33.92,33.92,0,0,0-13.68-3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M28.39,74.42c-5.62,0-12.54,1.64-21,5.67h0A75.62,75.62,0,0,0,0,112.77H0a75.92,75.92,0,0,0,2.61,19.77h0c8.78-11.28,26.34-13.15,37.26-10h0A50.52,50.52,0,0,1,50.29,105h0c2.47-4.59.51-30.57-21.9-30.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M40.23,156.1h0a20.14,20.14,0,0,0-14.33,5.19,14.3,14.3,0,0,0-3.54,5.35c0-.06,4.08-10,17.87-10.54Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M39.87,122.56a50.1,50.1,0,0,0,.37,33.55h0a23.22,23.22,0,0,0-9.64,2.33c-6.18-11.25-8.66-24.35-6-37A40.15,40.15,0,0,1,39.87,122.56Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M39.87,122.56A49.22,49.22,0,0,0,38.34,128c-19.17-4.63-35.73,4.58-35.73,4.58,5.28-6.79,13.74-10.17,22-11.09l1.28-.13h0l1.27-.08h0c.41,0,.82,0,1.22,0h3l.31,0,.33,0,.31,0h.25l.37,0,.24,0,.39,0,.18,0,.41,0,.17,0,.44,0,.14,0,.45.06.11,0,.48.07.1,0,.48.08h0l.51.1h.07l.49.11h0l.5.12h.06l.5.12h0l.5.13,0,0,.5.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M45.44,166.4a50.66,50.66,0,0,0,37.11,22.53c-22.73.79-42.06-12.5-51.95-30.49a23.22,23.22,0,0,1,9.64-2.33h0A49.94,49.94,0,0,0,45.44,166.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M45.44,166.4a50.66,50.66,0,0,0,37.11,22.53C49.44,187,40.24,156.11,40.24,156.11A49.94,49.94,0,0,0,45.44,166.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M22.37,166.65c0-.06,4.08-10,17.87-10.54h0c.41,1.12.86,2.21,1.34,3.29A30.41,30.41,0,0,0,22.37,166.65Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M50.29,105h0A52.32,52.32,0,0,1,55,100.43h0a50.5,50.5,0,0,1,15.65-9.05h0L83.55,56.69,56.63,39A77,77,0,0,0,10.29,74.6h0q-1.56,2.69-2.9,5.49h0C41.92,74.18,50.29,105,50.29,105Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M50.29,105h0S41.92,74.18,7.39,80.09c11.72-2.65,25.28.07,34.3,9.69C44.88,93.17,49.66,100.22,50.29,105Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M56.63,39,73.42,50C51.74,55.84,32.5,64.85,19.56,79.5a47.27,47.27,0,0,0-12.17.59q1.34-2.81,2.9-5.49A77,77,0,0,1,56.63,39Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M76.55,75.55,70.67,91.38A50.5,50.5,0,0,0,55,100.43,52.32,52.32,0,0,0,50.29,105h0a39.12,39.12,0,0,0-7-13c7.73-6.38,18-11.85,31-15.84C75,76,75.78,75.74,76.55,75.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M56.63,39,83.55,56.69,70.67,91.38a51,51,0,0,0-6.71,3C74.59,59.43,56.63,39,56.63,39Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M39.87,122.56c-10.92-3.16-28.48-1.29-37.26,10,2.93-4.62,8.78-8.07,14.19-9.79C23.85,120.52,33.91,120.25,39.87,122.56Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M2.61,132.55A75.92,75.92,0,0,1,0,112.78H0A75.77,75.77,0,0,1,7.39,80.09a47.27,47.27,0,0,1,12.17-.59C8.24,92.32,1.73,109.45,2.61,132.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M50.29,105a50.52,50.52,0,0,0-10.42,17.56,40,40,0,0,0-15.23-1.1c2.27-10.59,8.19-20.85,18.61-29.44a39.12,39.12,0,0,1,7,13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M50.29,105a52.21,52.21,0,0,0-3.65,4.49C36.87,78,7.39,80.09,7.39,80.09,41.92,74.18,50.29,105,50.29,105Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M181.79,36.37H76.39A75.84,75.84,0,0,0,56.63,39h0c13.46,8.86,21.82,31.44,14,52.4h0a49.81,49.81,0,0,1,16.85-2.92h21.16c19.64,0,36.8-19.41,42.2-37.63h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M70.67,91.38c7.78-21-.58-43.54-14-52.4,7.69,4.52,12.82,13.34,15.28,21.57C74.87,70.44,74.62,82,70.67,91.38Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M67.85,51.61A35.43,35.43,0,0,0,56.63,39a75.84,75.84,0,0,1,19.76-2.61h105.4C148.51,39.69,104.13,40.69,67.85,51.61Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M108.68,88.46H87.52a49.81,49.81,0,0,0-16.85,2.92,48,48,0,0,0,3-15l.64-.2c25.79-7.88,55.05,9.49,76.61-25.35-5.4,18.22-22.56,37.63-42.2,37.63Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M82.55,188.93a50.33,50.33,0,0,1-31.28-15.24,22.51,22.51,0,0,0,6.56,0c7.84,11.32,24.72,15.22,24.72,15.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M17.84,0a24.87,24.87,0,0,0,22.6,14.63H166.85a21.87,21.87,0,0,1,21.74,21.72h0c.08,8.27-2.73,15.27-9,20.69h0c-.39.34-.79.66-1.19,1,7.92-3.75,13.27-10.89,13.27-21.65a24.86,24.86,0,0,0-24.8-24.79H40.44c-9.35,0-17-4-22.52-11.46h0L17.84,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "120.41 94.84 137.04 114.69 126.23 135.6 140.15 114.5 122.32 93.23 120.41 94.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "107.27 94.39 123.9 114.24 119.8 125 127.01 114.06 109.19 92.79 107.27 94.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "94.14 93.95 110.77 113.8 106.66 124.55 113.87 113.61 96.05 92.35 94.14 93.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "81 93.5 97.63 113.35 93.52 124.11 100.73 113.17 82.91 91.9 81 93.5"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M108.68,88.46H87.52a49.81,49.81,0,0,0-16.85,2.92,48,48,0,0,0,3-15l.64-.2c25.79-7.88,55.05,9.49,76.61-25.35-5.4,18.22-22.56,37.63-42.2,37.63Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrawn);
export default __webpack_public_path__ + "static/media/prawn.1bf63a33ae51c0d19a076fa2a4e36990.svg";
export { ForwardRef as ReactComponent };